import React from 'react';

export const ToolTipInfo = (props) => (
	<div className="tooltip-info">
		<div className="tooltip-inner-content">
			<h3 className="h2-style">{props.title}</h3>
			<p>{props.info}</p>
			<button 
				onClick={props.handleClick}
				className="close-modal"></button>
		</div>
	</div>
);


// WEBPACK FOOTER //
// ./src/components/ToolTip/ToolTipInfo.js